<template>
<div class="content">
	<!-- Content Header (Page header) -->
	<section class="content-header">
		<div class="container-fluid">
			<div class="page-header">
				<h1>{{ $t($route.name) }}</h1>
			</div>
		</div>
	</section>

	<!-- Main Content -->
	<div class="container-fluid" v-if="dataReady">

		<div class="card">
			<div class="card-block row">

				<table id="datatables" class="table table-striped table-no-bordered table-hover table-responsive" cellspacing="0" width="100%" style="width: 100%;">
					<thead>
							<tr>
								<th class="sorting_asc" tabindex="0" style="width: 143px;">Име</th>
								<th class="sorting" tabindex="0" style="width: 215px;">Статус</th>
								<th class="sorting" tabindex="0" style="width: 107px;">Град</th>
								<th class="sorting" tabindex="0" style="width: 10px;">Действия</th>
							</tr>
					</thead>
					<tbody>
						<tr v-for="registration in records.items" role="row">
							<td>
								<router-link :to="'/moderate/registration/' + registration.id">{{registration.name}}</router-link>
							</td>
							<td><span :class="'badge badge-' + {new: 'info', edited: 'success', rejected: 'danger'}[registration.status]">{{ $t('status.family_' + registration.status) }}</span></td>
							<td>{{ $config.lists.countries[registration.country].text }} / {{ $config.lists.states[registration.state].text }}</td>
							<td class="text-center">
								<router-link :to="'/moderate/registration/' + registration.id" class="btn btn-small btn-primary btn-icon edit"><i class="fa fa-eye"></i></router-link>
							</td>
						</tr>

					</tbody>
				</table>
			</div><!--/.Card block-->
		</div><!--/.card-->
	</div><!-- end of external card-block -->
		<f-pager :total="records.total" :clickhandler="pageClick"></f-pager>
	</div>
</template>

<script>
module.exports = {
	data: function () {
		return {
			records: [],
			dataReady: false
		};
	},
	created: function () {
		this.fetchData();
	},
	watch: {
		$route: 'fetchData'
	},
	methods: {
		fetchData: function (pageNum) {
			pageNum = pageNum || 1;
			this.$http.get('backend://registration?limit=' + this.$config.rpp + '&page=' + pageNum).then((response) => {
				this.records = response.body;
				this.dataReady = true;
			}).catch(this.$http.toastCatcher);
		},
		pageClick: function (pageNum) {
			this.fetchData(pageNum);
		},
		getChildAge: function (child) {
			var currentYear = new Date().getFullYear();
			return (currentYear - child.birthYear);
		}
	}
};
</script>
<style>
.overlay .background {
	height: 170px;
	width: 100%;
	transition: all .2s linear;
	border-bottom-left-radius: 0;
	border-bottom-right-radius: 0;
	background-position: center;
	background-size: cover;
}
.card-title {
	white-space: nowrap;
	text-overflow: ellipsis;
	overflow: hidden;
}
.card-profile {
	max-height: 300px;
}
.child-icon {
	font-size: 20px;
	margin-top: 5px;
}
.child-age {
	font-size: 12px;
	margin:0 2px;
}
.card-footer p {
	white-space: nowrap;
	text-overflow: ellipsis;
	overflow: hidden;
	min-height: 26px;
}

</style>



// WEBPACK FOOTER //
// RegistrationList.vue?50c557dc